import { FaRegCheckCircle } from 'react-icons/fa';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface HotelApprovalStatusProps {
  isError: boolean;
}

interface CardProps {
  havePayAtDestination: boolean;
}

export const Card = styled.div<CardProps>`
  background: ${({ theme }) => theme.dataCardHotels.background};
  min-height: ${({ havePayAtDestination }) => (havePayAtDestination ? '258px' : '242px')};
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 ${({ theme }) => theme.dataCardHotels.shadow};
  overflow: hidden;
  cursor: pointer;

  margin: 0 16px 16px;

  @media ${({ theme }) => theme.device.desktop} {
    margin: 0 0 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 50%;
  overflow: hidden;
  border-bottom: 1px solid ${({ theme }) => theme.dataCardHotels.border};

  &:before {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 89%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('/corporate/images/hotel_icon_150155.svg');
    z-index: 0;
  }
`;

export const CardContent = styled.div`
  padding: 16px;
`;

export const CardRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CardHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  width: 114px;
  height: 22px;
  top: 19px;
  right: 15px;
  border-radius: 87px;
  background: ${({ theme }) => theme.dataCardHotels.gradient};
`;

export const LabelText = styled.span`
  font-size: 10px;
  margin: 0 5px 0 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: ${({ theme }) => theme.dataCardHotels.labelTextColor};
`;

export const HotelApprovalStatus = styled.span<HotelApprovalStatusProps>`
  font-size: 12px;
  line-height: 1.5;
  text-align: right;
  min-width: fit-content;
  min-height: 18px;

  color: ${({ isError }) => (isError ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.GreenPantone)};
`;

export const HotelTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.dataCardHotels.hotelTitle};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const HotelSubtitle = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CardFooter = styled.div`
  height: 20%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;

export const CardFooterPayAtDestination = styled.div`
  height: 20%;
  display: flex;
  align-items: center;
  padding: 0 15px;
`;

export const CardFooterPayAtDestinationText = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CardFooterPrice = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
`;

export const CardFooterBoardDescription = styled.span`
  font-size: 11px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
  margin-left: 2px;
`;

export const CardFooterScore = styled.div`
  display: flex; 
  align-items: center; 
  gap: 6px; 
  font-size: 11px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  width: 200px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-right: 8px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const CardFooterScoreValue = styled.span`
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  background: ${({ theme }) => theme.primaryBackgroundColor};
  color: ${({ theme }) => theme.primaryColor};
  padding: 1px 10px; 
  border-radius: 8px; 
`;

export const CardFooterScoreText = styled.span`
  font-size: 12px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;  
`;

export const CardFooterTotalNights = styled.span`
  font-size: 11px;
  font-weight: 100;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

interface CardFooterRefundableProps {
  isRefundable?: boolean;
}

export const CardTaxesIncluded = styled.span`
  font-size: 11px;
  font-weight: 200;
`;


export const CardFooterRefundable = styled.span<CardFooterRefundableProps>`
  font-size: 11px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: ${({ isRefundable, theme }) => isRefundable ? '#13B84E' : theme.dataCardHotels.cleanColor};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 12px;
`;

export const CardFooterFullPrice = styled.span`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray};
  min-width: fit-content;
`;

export const CheckCircleIcon = styled(FaRegCheckCircle)`
  font-size: 14px;
  color: ${({ theme }) => theme.dataCardHotels.cleanColor} !important;
  margin-top: 4px;
  margin-right: 4px;
  @media (min-width: 446px) {
    align-self: center;
    margin-top: 0;
  }
`;
